import type { TabelaPrecoProdutoPacoteBarraPartial } from '@/features/tabela-preco/types/TabelaPrecoProdutoPacoteBarraPartial';
import type { TabelaPrecoProdutoPartial } from '@/features/tabela-preco/types/TabelaPrecoProdutoPartial';
import { calcularPrecoVendaProdutoPacote } from '@/features/produto/util/preco';
import { TabelaPrecoExcecaoTipoPreco } from '@/features/tabela-preco/types/enum';
import { unreachable } from '@/std/util';

export type TabelaPrecoPartialRow = {
    tpe_tipo_preco: TabelaPrecoExcecaoTipoPreco | null | undefined;
    tpe_preco: number | null | undefined;
    produto: TabelaPrecoProdutoPartial | null | undefined;
    produto_pacote_barra: TabelaPrecoProdutoPacoteBarraPartial | null | undefined;
};

function applyTipoPreco(
    tpeTipoPreco: TabelaPrecoExcecaoTipoPreco | null | undefined,
    tpePreco: number,
    precoBase: number,
): number {
    switch (tpeTipoPreco) {
        case null:
        case undefined:
            return 0;
        case TabelaPrecoExcecaoTipoPreco.PrecoEspecificado:
            return tpePreco;
        case TabelaPrecoExcecaoTipoPreco.PrecoProdutoOuPacoteBarras:
            return precoBase;
        case TabelaPrecoExcecaoTipoPreco.PercentualAcrescimo:
            return precoBase + (precoBase * tpePreco) / 100;
        case TabelaPrecoExcecaoTipoPreco.PercentualDesconto:
            return precoBase - (precoBase * tpePreco) / 100;
        case TabelaPrecoExcecaoTipoPreco.ValorAcrescimo:
            return precoBase + tpePreco;
        case TabelaPrecoExcecaoTipoPreco.ValorDesconto:
            return precoBase - tpePreco;
        default:
            return unreachable(tpeTipoPreco);
    }
}

function getTabelaPrecoValueFromProduto(row: TabelaPrecoPartialRow): number {
    const valorProduto = row.produto?.pro_preco_venda ?? 0;
    return applyTipoPreco(row.tpe_tipo_preco, row.tpe_preco ?? 0, valorProduto);
}

function getTabelaPrecoValueFromPacote(row: TabelaPrecoPartialRow): number {
    const { preco } = calcularPrecoVendaProdutoPacote({
        pcb_multiplicador: row.produto_pacote_barra?.pcb_multiplicador ?? 0,
        pcb_tipo_preco: row.produto_pacote_barra?.pcb_tipo_preco,
        pcb_valor: row.produto_pacote_barra?.pcb_valor ?? 0,
        pro_preco_venda: row.produto?.pro_preco_venda ?? 0,
    });

    return applyTipoPreco(row.tpe_tipo_preco, row.tpe_preco ?? 0, preco);
}

export function getTabelaPrecoValue(row: TabelaPrecoPartialRow): number {
    const minimo = row.produto?.pro_preco_minimo ?? 0;

    if (row.produto_pacote_barra) {
        return Math.max(getTabelaPrecoValueFromPacote(row), minimo);
    }

    return Math.max(getTabelaPrecoValueFromProduto(row), minimo);
}
